var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-confirm-professional-booking p-4" },
    [
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-8 offset-md-2" },
          [
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: {
                  to: _vm.isLineLoggedIn
                    ? "/line-liff/bookings"
                    : "/my-reservations"
                }
              },
              [_vm._v(_vm._s(_vm.$t("message.menu.my_reservations")))]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: { to: "/service-requests/" + _vm.serviceRequest.id }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.my_reservations.service_request_detail")
                    ) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.my_reservations.payment")) +
                "\n    "
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-lg-6 offset-lg-3" },
          [
            !_vm.serviceRequest ? _c("loader") : _vm._e(),
            _vm._v(" "),
            _vm.serviceRequest && _vm.order
              ? _c("div", [
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body text-left pb-2" }, [
                      _vm._v(
                        "\n            #" + _vm._s(_vm.order.code) + " - "
                      ),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$options.filters.serviceParentName(
                              _vm.order.service_id,
                              _vm.globalState.services
                            )
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row no-gutters pt-3" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.service_request.service_cost")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 text-right" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.serviceRequest.service_cost
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.serviceRequest.promotion_cost
                          ? _c("section", [
                              _vm.serviceRequest.payment_status === 0
                                ? _c("div", { staticClass: "radio" }, [
                                    _c(
                                      "label",
                                      { staticClass: "custom-inline" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "label-span" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.service_request.service_request_payment_pay_promotion"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.paymentType,
                                              expression: "paymentType"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "type_payment",
                                            required: "",
                                            value: "promotion"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.paymentType,
                                              "promotion"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.paymentType = "promotion"
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "checkmark" })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.serviceRequest.payment_status === 3
                                ? _c("div", { staticClass: "radio" }, [
                                    _c(
                                      "label",
                                      { staticClass: "custom-inline" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "label-span" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.service_request.service_request_payment_pay_total"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.paymentType,
                                              expression: "paymentType"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "type_payment",
                                            required: "",
                                            value: "full"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.paymentType,
                                              "full"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.paymentType = "full"
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "checkmark" })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.serviceRequest.payment_status === 3
                                ? _c("hr")
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPaidServiceRequestCost(
                                _vm.serviceRequest,
                                "promotion"
                              )
                                ? _c("div", { staticClass: "radio" }, [
                                    _c(
                                      "label",
                                      { staticClass: "custom-inline" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "label-span" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.serviceRequest &&
                                                    _vm.serviceRequest
                                                      .payment_status === 1
                                                    ? _vm.$t(
                                                        "message.service_request.service_request_payment_pay_remaining"
                                                      )
                                                    : _vm.$t(
                                                        "message.service_request.service_request_payment_pay_deposit"
                                                      )
                                                ) +
                                                "\n                  "
                                            ),
                                            _vm.serviceRequest
                                              .payment_status === 3
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-remark"
                                                  },
                                                  [
                                                    _c("br"),
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.service_request.service_request_payment_pay_remaining_balance_remark"
                                                        )
                                                      ) + "\n                  "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.paymentType,
                                              expression: "paymentType"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "type_payment",
                                            required:
                                              _vm.serviceRequest
                                                .payment_status === 1,
                                            value: "deposit"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.paymentType,
                                              "deposit"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.paymentType = "deposit"
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "checkmark" })
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _c("section", [
                              _vm.serviceRequest.payment_status === 0
                                ? _c("div", { staticClass: "radio" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-inline",
                                        attrs: { for: "type_payment1" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "label-span" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.service_request.service_request_payment_pay_total"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.paymentType,
                                              expression: "paymentType"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "type_payment",
                                            required: "",
                                            id: "type_payment1",
                                            value: "full"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.paymentType,
                                              "full"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.paymentType = "full"
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "checkmark" })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.serviceRequest.payment_status === 0
                                ? _c("hr")
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "radio" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-inline",
                                    attrs: { for: "type_payment2" }
                                  },
                                  [
                                    _c("span", { staticClass: "label-span" }, [
                                      _vm._v(
                                        "\n                              " +
                                          _vm._s(
                                            _vm.serviceRequest &&
                                              _vm.serviceRequest
                                                .payment_status === 1
                                              ? _vm.$t(
                                                  "message.service_request.service_request_payment_pay_remaining"
                                                )
                                              : _vm.$t(
                                                  "message.service_request.service_request_payment_pay_deposit"
                                                )
                                          ) +
                                          "\n                              "
                                      ),
                                      _vm.serviceRequest.payment_status === 0
                                        ? _c(
                                            "span",
                                            { staticClass: "text-remark" },
                                            [
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.service_request.service_request_payment_pay_remaining_balance_remark"
                                                  )
                                                ) +
                                                  "\n                              "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.paymentType,
                                          expression: "paymentType"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "type_payment",
                                        required:
                                          _vm.serviceRequest.payment_status ===
                                          1,
                                        id: "type_payment2",
                                        value: "deposit"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.paymentType,
                                          "deposit"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.paymentType = "deposit"
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "checkmark" })
                                  ]
                                )
                              ])
                            ]),
                        _vm._v(" "),
                        _vm.calculateServiceCost
                          ? [
                              _c("hr"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row no-gutters footer" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-6 text-left" },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.service_request.all_amount_due"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 text-right" },
                                    [
                                      _vm.paymentType
                                        ? _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(
                                                  _vm.calculateServiceCost
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.paymentType
                    ? _c(
                        "div",
                        { staticClass: "pt-3" },
                        [
                          _c("payment-methods", {
                            ref: "paymentMethods",
                            attrs: { displayPromptpay: false },
                            on: {
                              onSelectedPaymentMethod: _vm.updatePaymentMethod,
                              onSelectedCreditCard: _vm.applyUserCreditCard,
                              onRequestedSavingTempData: _vm.saveTempData,
                              onSelectedFileUpload: _vm.setFileUpload,
                              onSuccessQrPayment: _vm.displaySuccessDialog
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.paymentType && _vm.paymentMethod
                    ? _c(
                        "div",
                        {
                          staticClass: "row no-gutters px-2 d-flex h-100 pt-4"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 text-left align-self-center"
                            },
                            [
                              _c("h3", { staticClass: "-status-new m-0" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.calculateServiceCost
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.all_vat_included"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 text-right align-self-center"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-info btn-lg",
                                  attrs: { disabled: _vm.isLoading },
                                  on: {
                                    click: function($event) {
                                      return _vm.submitPayment()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.isLoading
                                          ? _vm.$t("message.processing")
                                          : _vm.$t(
                                              "message.button.confirm_payment"
                                            )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isLineLoggedIn
        ? _c(
            "div",
            { staticClass: "container text-center py-2" },
            [
              _c(
                "router-link",
                { attrs: { to: "/service-requests/" + _vm.serviceRequest.id } },
                [
                  _c("i", { staticClass: "fas fa-angle-left" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.booking.new_booking.back")) +
                      "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1950b0c7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1950b0c7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/ServiceRequestPayment.vue
// module id = 2149
// module chunks = 0